import React, { useContext, useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import ColorListBox from '../ColorsListFronts';
import SummaryBar from '../SummaryBar';
import { getFrontsByType } from '../../store/actions/products';
import { getAddons } from '../../store/actions/addons';
import { connect } from 'react-redux';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { GAContext } from 'contexts/GAContext';

import PopUp from '../popup/PopUp';
import ColorsGroupPopup from '../popup/ColorsGroupPopup';
import BrakePopup from '../popup/BrakePopup';
import FrontsInfoPopup from '../popup/FrontsInfoPopup';
import { ToastContainer, toast } from 'react-toastify';
import PopUpButton from '../popup/PopUpButton';
import Loader from '../Loader';
import calculatePrice from '../../helpers/calculatePrice';
import { rebuildFronts, someFrontHasGlass } from '../../helpers/wardrobe';
import { getAccessories } from 'store/actions/accessories';
import { getDedicatedAccessories } from 'store/actions/accessories';

const EMPTY_ARRAY = [];

const arrayEquals = (list1, list2) => {
  if (list1.length !== list2.length) {
    return false;
  }

  return list1.every((value, idx) => value === list2[idx]);
};

const setActiveFront = (panelActive, activeFront, activeWardrobe) => {
  if (panelActive && activeFront !== undefined) {
    const door = activeFront.split('_');
    let panel = activeWardrobe.fronts[door[1]][door[2]];
    return panel;
  }
};

const checkPanelExists = activeWardrobe => {
  let cntPanels = 0;
  if (!activeWardrobe.is_hinged) {
    activeWardrobe.fronts.forEach(item => {
      item.forEach(panel => {
        cntPanels += panel && panel.hasOwnProperty('safo') ? 1 : 0;
      });
    });
  }
  return cntPanels > 0;
};

const notify = () => {
  toast.error('Wybierz panel w celu doboru koloru', {
    closeOnClick: true,
    position: 'top-right',
    autoClose: 10000,
    toastId: 1, // show only one
  });
};

const SlidingFrontsConfig = props => {
  const {
    addonsList,
    frontList,
    frontColorList,
    frontGroupList,
    activeFront,
    setOpenDoorsState,
    setActiveFrontsPanels,
    activeFrontPattern,
    setFrontPattern,
    frontPatterns,
    getAddons,
    setPrice,
  } = props;

  const history = useHistory();

  const [state, setState] = useState({
    panelCount: 3,
    panelActive: false,
    panelDefaultLoad: false,
    selectedPattern: EMPTY_ARRAY,
  });

  const [frontListToShow, setFrontListToShow] = useState([]);

  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { GA } = useContext(GAContext);
  const [checkBrake, setCheckBrake] = useState(
    wardrobesConfigs[activeWardrobe].brake === true ? true : false,
  );
  const [activeBrake, setActiveBrake] = useState(true);
  const [defaultFronts, setDefaultFronts] = useState('normal');

  let wardrobe = wardrobesConfigs[activeWardrobe];
  const activeFrontTmp = setActiveFront(
    state.panelActive,
    activeFront,
    wardrobesConfigs[activeWardrobe],
  );

  const panelsCount = useMemo(() => {
    let panelsCount = 3;

    if (wardrobe.hasOwnProperty('panels')) {
      panelsCount = wardrobe.panels;
    } else {
      if (wardrobe.dimensions.y > 218) {
        panelsCount = 4;
      }
    }
    return panelsCount;
    /* eslint-disable-next-line */
  }, [activeWardrobe, wardrobesConfigs]);

  const assignBrake = isChecked => {
    let newWardrobe = {
      ...wardrobe,
      brake: isChecked,
    };

    if (!newWardrobe.hasOwnProperty('addons')) {
      newWardrobe.addons = {};
    }
    if (wardrobe.is_hinged) {
      if (!newWardrobe.addons.hasOwnProperty('brake')) {
        newWardrobe.addons.brake = null;
      }
    }

    newWardrobe.addons.brake = isChecked
      ? addonsList.find(item => item.safo.includes('SEVROMATIC'))
      : null;
    wardrobesConfigs[activeWardrobe] = newWardrobe;
    setWardrobesConfigs(wardrobesConfigs);
    setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
  };

  const setBrake = isBrake => {
    setCheckBrake(isBrake);
    assignBrake(isBrake);
    if (wardrobesConfigs[activeWardrobe].addons.brake === null) {
    }
  };

  const setFrontsPatterns = pattern => {
    wardrobe.withoutDoor = false;
    const wardrobes = [...wardrobesConfigs];
    let activeWardrobeObject = { ...wardrobes[activeWardrobe] };
    const fronts = [...activeWardrobeObject.fronts[0], ...activeWardrobeObject.fronts[1]];

    setDefaultFronts(pattern);
    setFrontPattern(pattern);

    activeWardrobeObject.fronts = [
      [fronts[4], fronts[1], fronts[6], fronts[3]],
      [fronts[0], fronts[5], fronts[2], fronts[7]],
    ];

    activeWardrobeObject.fronts = rebuildFronts(
      activeWardrobeObject.fronts,
      activeWardrobe.panels,
      frontList,
    );
    activeWardrobeObject.front_pattern_type = pattern;
    activeWardrobeObject.front_pattern = frontPatterns[panelsCount][pattern];

    wardrobes[activeWardrobe] = activeWardrobeObject;
    setWardrobesConfigs(wardrobes);
  };

  const getSelectFromPattern = useMemo(() => {
    if (!activeFront) {
      return EMPTY_ARRAY;
    }
    const panelsToCheck = frontPatterns[panelsCount]
      ? frontPatterns[panelsCount][activeFrontPattern][activeFront]
      : EMPTY_ARRAY;

    return panelsToCheck;
  }, [activeFront, activeFrontPattern, frontPatterns, panelsCount]);

  useEffect(() => {
    if (!arrayEquals(state.selectedPattern, getSelectFromPattern)) {
      setState({
        ...state,
        panelActive: true,
        panelCount: panelsCount,
        selectedPattern: getSelectFromPattern,
      });
      setActiveFrontsPanels(getSelectFromPattern);
    }
  }, [getSelectFromPattern, panelsCount, setActiveFrontsPanels, state]);

  const changeFrontMaterial = frontObj => {
    wardrobe.withoutDoor = false;
    const panelsToCheck = getSelectFromPattern;
    if (panelsToCheck.length) {
      panelsToCheck.forEach(position => {
        const active = position.split('_');
        wardrobe.fronts[active[1]][active[2]] = frontObj;
      });
      setWardrobesConfigs(wardrobesConfigs);
    }
    GA('Front configuration', 'Select fronts of wardrobe');
  };

  const setDefaultFrontsByPattern = (defaultFrontsColors, panels) => {
    Object.keys(defaultFrontsColors).map(frontIdx => {
      const active = frontIdx.split('_');
      const frontColor = defaultFrontsColors[frontIdx];
      const panelPosition = parseInt(active[2]);
      const outsidePanel = panelPosition === 0 || panelPosition === panels;

      let frontInfo = null;

      let colorsListTmp = frontList.filter(item =>
        outsidePanel ? item.safo.includes('Z-') : item.safo.includes('W-'),
      );

      let frontColors = frontColor.split('/');

      // if mirror 'LUS' or glass 'SZK'
      if (frontColor.includes('SZK') || frontColor.includes('LUS')) {
        frontInfo = colorsListTmp.find(item => {
          return item.safo.includes(frontColors[0]) && item.safo.includes(frontColors[1]);
        });
      } else {
        frontInfo = colorsListTmp.find(item => {
          return (
            !item.safo.includes('SZK') &&
            !item.safo.includes('LUS') &&
            item.safo.includes(frontColor)
          );
        });
      }

      if (frontInfo && frontInfo.hasOwnProperty('safo')) {
        wardrobe.fronts[active[1]][active[2]] = frontInfo;
      }

      return defaultFronts[frontIdx];
    });
  };

  const dimensions = useMemo(() => {
    return wardrobesConfigs[activeWardrobe].dimensions.x;
  }, [activeWardrobe, wardrobesConfigs]);

  useEffect(() => {
    getAddons(dimensions);
  }, [dimensions, getAddons]);

  useEffect(() => {
    if (!state.panelDefaultLoad) {
      const wardrobe = wardrobesConfigs[activeWardrobe];

      let activeTypes = wardrobe.types;
      let activeDimensions = wardrobe.dimensions;

      activeTypes = Object.keys(activeTypes);
      activeTypes.shift(); // usuniecie typu korpus
      activeTypes.push(2); // 2 to fronty
      props.getFrontsByType(activeTypes, activeDimensions);
      setState(prev => {
        return { ...prev, panelDefaultLoad: true };
      });
    }
  }, [wardrobesConfigs, activeWardrobe, state, props]);

  useEffect(() => {
    if (!wardrobe.is_hinged && !wardrobe.withoutDoor) {
      if (addonsList.length === 0) {
        getAddons(wardrobe.dimensions.x);
      } else {
        wardrobe.addons.fronts = addonsList.filter(
          item => item.safo.includes('FRN') && item.dimensions.y === wardrobe.dimensions.y,
        );
      }
    }

    /* eslint-disable-next-line */
  }, [addonsList.length, wardrobe.dimensions.y, activeWardrobe, wardrobe.withoutDoor]);

  useEffect(() => {
    setPrice();
    /* eslint-disable-next-line */
  }, [activeFrontTmp]);

  useEffect(() => {
    if (wardrobesConfigs[activeWardrobe]) {
      let wardrobe = wardrobesConfigs[activeWardrobe];

      if (wardrobe.is_hinged) {
        return;
      }

      if (defaultFronts && !checkPanelExists(wardrobe)) {
        setDefaultFrontsByPattern(wardrobe.defaultFronts, parseInt(wardrobe.panels) - 1);
      }
    }
    /* eslint-disable-next-line */
  }, [
    activeWardrobe,
    frontColorList,
    getAddons,
    getSelectFromPattern,
    props,
    setActiveFrontsPanels,
    setOpenDoorsState,
    setWardrobesConfigs,
    state,
    wardrobesConfigs,
  ]);
  useEffect(() => {
    if (wardrobesConfigs[activeWardrobe].addons.brake === null) {
      assignBrake(false);
    }
    setActiveBrake(true);
    if (!wardrobe.is_hinged) {
      if (!wardrobe.addons.hasOwnProperty('safo')) {
        if (wardrobe.fronts[0].length) {
          if (someFrontHasGlass(wardrobe)) {
            setBrake(true);
            setActiveBrake(false);
          }
        } else {
          setBrake(false);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addonsList, activeWardrobe, wardrobe.fronts, activeFrontTmp]);

  useEffect(() => {
    const panels = parseInt(wardrobesConfigs[activeWardrobe].panels) - 1;
    if (activeFront) {
      const active = activeFront.split('_');
      const panelPosition = parseInt(active[2]);
      const outsidePanel = panelPosition === 0 || panelPosition === panels;
      const frontToShow = [...frontList].filter(item =>
        outsidePanel ? item.safo.includes('Z-') : item.safo.includes('W-'),
      );
      setFrontListToShow([...frontToShow]);
    }
  }, [frontList, activeFront, wardrobesConfigs, activeWardrobe]);

  const sortedFrontListToShow = frontListToShow.sort((a, b) => {
    return a.safo.localeCompare(b.safo);
  });

  useEffect(() => {
    if (wardrobe) {
      let safoCode = wardrobe.safo;
      props.getDedicatedAccessories(safoCode);
      props.getAccessories(safoCode, wardrobe.dimensions.x, wardrobe.dimensions.z);
    }
    /* eslint-disable-next-line */
  }, [activeWardrobe]);

  const skipAction = () => {
    wardrobe.withoutDoor = true;
    wardrobe.addons.fronts = [];
    wardrobe.addons.brake = null;
    wardrobe.addons.track = null;
    setActiveBrake(false);
    setBrake(false);

    history.push('/accessories-configuration');
  };

  return (
    <div>
      {/* {wardrobe.dimensions.y === 218 ? null : (
        <div className="container__text">
          <PopUpButton icon="help-circle" popupName="frontsInfoPopup" />
        </div>
      )} */}
      {wardrobe.dimensions.x > 100 && (
        <div className="container__text container__text--position">
          <p>Wybierz panel w celu konfiguracji drzwi przesuwnych</p>
          {wardrobe.dimensions.y === 218 && (
            <div className="wardrobe-fronts__button" onClick={skipAction}>
              lub kup szafę bez drzwi
            </div>
          )}
        </div>
      )}
      {wardrobe.dimensions.y === 218 ? null : (
        <div className="container__icon">
          <PopUp popupName="frontsInfoPopup" title="Informacje o panelach">
            <FrontsInfoPopup />
          </PopUp>
          <img
            src={`${process.env.PUBLIC_URL}/img/lowerWardrobe.svg`}
            onClick={defaultFronts === 'normal' ? null : () => setFrontsPatterns('normal')}
            alt="normal"
            title="Wybieranie Normalne"
            className={`${defaultFronts === 'normal' ? 'active' : ''}`}
          />
          <img
            src={`${process.env.PUBLIC_URL}/img/higherWardrobe.svg`}
            onClick={defaultFronts === 'chessboard' ? null : () => setFrontsPatterns('chessboard')}
            alt="chessboard"
            title="Wybieranie Szachowe"
            className={`${defaultFronts === 'chessboard' ? 'active' : ''}`}
          />
          <div className="wardrobe-fronts__extra-info">
            {wardrobe.dimensions.y !== 218 && (
              <PopUpButton icon="help-circle" popupName="frontsInfoPopup" />
            )}
            <div className="wardrobe-fronts__button" onClick={skipAction}>
              lub kup szafę bez drzwi
            </div>
          </div>
        </div>
      )}
      <div className="container fronts-config">
        <div className="fronts-config__container">
          {frontListToShow.length ? (
            <ColorListBox
              title={`Kolor drzwi: ${activeFrontTmp ? activeFrontTmp.name : ''}`}
              changeMaterial={activeFront ? changeFrontMaterial : () => notify()}
              groupList={frontGroupList}
              colorsList={sortedFrontListToShow}
              frontColor={activeFrontTmp ? activeFrontTmp.slug : ''}
            />
          ) : (
            <Loader />
          )}
        </div>
        <SummaryBar
          btnText="Przejdź dalej"
          btnIcon={true}
          btnLink="/wardrobe-handles-configuration"
          propClass={frontListToShow.length ? 'active' : ''}
        />
      </div>
      <ToastContainer />
      {!wardrobe.is_hinged && (
        <>
          <div className="accessories__check-button">
            <button
              disabled={!activeBrake}
              onClick={() => setBrake(!checkBrake)}
              className={`accessories-list__check-button ${checkBrake ? 'active' : ''} ${
                !activeBrake ? 'display' : ''
              }`}>
              <span className="icon-checkmark" />
            </button>
            <p className={`${!activeBrake ? 'display' : ''}`}>Hamulec do drzwi przesuwnych</p>
            <PopUpButton icon="help-circle" iconClass="icon" popupName="brakePopup" />
          </div>
        </>
      )}
      <PopUp title="Informacje o hamulcach" popupName="brakePopup">
        <BrakePopup />
      </PopUp>
      <PopUp title="Informacje o drzwiach" popupName="colors-group">
        <ColorsGroupPopup colorGroups={frontGroupList} colorLists={frontListToShow} />
      </PopUp>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    frontColorList: state.products.frontsOutside,
    frontList: state.products.fronts,
    frontGroupList: state.products.frontsGroup,
    defaultFront: state.defaults.front,
    defaultHull: state.defaults.hull,
    addonsList: state.addons.addons,
    frontPatterns: state.defaults.frontPatterns,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAccessories: (safo, width, depth) => dispatch(getAccessories(safo, width, depth)),
    getDedicatedAccessories: safo => dispatch(getDedicatedAccessories(safo)),
    getFrontsByType: (wardrobeType, activeDimensions) =>
      dispatch(getFrontsByType(wardrobeType, activeDimensions)),
    getAddons: width => dispatch(getAddons(width)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SlidingFrontsConfig);
